<h4 class="sub-headline">{{subHeadline}}</h4>
<h2 class="headline" [innerHTML]="headline | breakline"></h2>
<p class="text" *ngIf="text" [innerHTML]="text | breakline"></p>
